/**
 * Event-bus is a very lightweight VUEX.
 * Here we simply use tiny-emitter as a global event bus.
 * Other components can fire events eg. `EventBus.emit(EventBus.Event.LOGIN)`
 * and listeners can subscribe with `EventBus.on(EventBus.Event.LOGIN, function(evt) { ... })
 */


//TODO: replace with node buit in https://nodejs.org/en/learn/asynchronous-work/the-nodejs-event-emitter

 import Emitter from 'tiny-emitter'
 
 const eventBus = new Emitter()

// "enum" for event names (the keys are case insensitive.)
eventBus.Event = {
	LOGIN: "login",																	// Fires after a successfull login. Event param is { team, polls, jwt }
	LOGOUT: "logout",																// Fires after logout is completed.
	POLLS_LOADED: "polls-loaded",  									// Fires when an array of polls was loaded from backend. Event param is the list of newly loaded polls
	POLL_LOADED: "poll-loaded",    									// One poll was loaded from the backend. Event param is that one poll
	MOBILE_DEBUG_LOG: "mobile-debug-log",				// Log entry for the mobile debug log. Event param is { level, message }
	CLICK_HEADER_CENTER: "click-header-center", 		// click on center area of liquido-header
	CLICK_HEADER_RIGHT: "click-header-right",
	ROOT_POPUP_CLICK_PRIMARY: "root-popup-click-primary",   	// click primary button in root popup modal
	ROOT_POPUP_CLICK_SECONDARY: "root-popup-click-secondary"	// click secondary button in root popup modal
}

export default eventBus


//MAYBE: This could also be implemented with the new VUE3 provide/inject mechanism: https://v3.vuejs.org/guide/component-provide-inject.html
